import { useState } from "react";
import { G } from "../../constants/theme";

export default function AppCard({ num, title, desc }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? G.surface : G.card,
        padding: "36px 30px",
        position: "relative",
        overflow: "hidden",
        transition: "background .2s",
        borderRight: `1px solid ${G.border}`,
      }}
    >
      {hovered && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: 2,
            background: G.green,
          }}
        />
      )}
      <div
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: 48,
          color: G.border,
          lineHeight: 1,
          marginBottom: 18,
        }}
      >
        {num}
      </div>
      <div
        style={{
          fontFamily: "monospace",
          fontSize: 11,
          letterSpacing: 1.5,
          color: G.green,
          textTransform: "uppercase",
          marginBottom: 10,
        }}
      >
        {title}
      </div>
      <p style={{ fontSize: 14, color: G.muted, lineHeight: 1.65 }}>{desc}</p>
    </div>
  );
}
